import PropTypes from 'prop-types';
import { bandOf } from './microSimBands';

/** One coloured bar per skill (bands: D12). */
const SkillBars = ({ skills, showDescriptions = false }) => (
  <div className="space-y-2.5">
    {skills.map((s) => {
      const b = bandOf(s.score);
      return (
        <div key={s.key}>
          <div className="flex items-baseline justify-between gap-2 text-sm">
            <span className="font-medium text-neutral-800">{s.label}</span>
            <span className={`shrink-0 font-bold tabular-nums ${b.text}`}>
              {s.score === null || s.score === undefined ? 'Not measured' : `${s.score}%`}
            </span>
          </div>
          <div className="mt-1 h-2 overflow-hidden rounded-full bg-neutral-100">
            <div className={`h-full rounded-full ${b.bar}`} style={{ width: `${s.score || 0}%` }} />
          </div>
          {showDescriptions && s.description && <p className="mt-0.5 text-xs text-neutral-400">{s.description}</p>}
        </div>
      );
    })}
  </div>
);

SkillBars.propTypes = {
  skills: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    score: PropTypes.number,
    description: PropTypes.string,
  })).isRequired,
  showDescriptions: PropTypes.bool,
};

export default SkillBars;
